/* eslint react/forbid-prop-types: 0 */
/* global globals, translations */
import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import PaymentsStore from '../../stores/PaymentsStore';

const PaymentOptions = (props) => {
  //
  const paymentMethods = PaymentsStore.getMethods();
  if (!paymentMethods.length) {
    return null;
  }

  //
  const { recurringMessage, onCheckout } = props;

  // Images on payment option buttons
  const images = {
    banklink: 'swedbank_46h.png',
    swedbank: 'swedbank_46h.png',
    ibanka: 'seb_46h.png',
    seb: 'seb_46h.png',
    inordea: 'luminor_46h.png',
    luminor: 'luminor_46h.png',
    citadele: 'citadele_46h.png',
    revolut: 'revolut_wm_black.png',
    card: 'cards_46h.png',
    sms: 'sms_46h.png',
    paypal: 'paypal_46h.png',
    paysera: 'paysera_46h.png',
    dev_test: 'test_46h.png',
  };
  const paymentImage = (adapter) => images[adapter] || images[adapter.split('_')[0]];

  //
  const options = [];
  const iOptions = [];

  //
  let counter = 1;
  let recurring = false;

  //
  paymentMethods.forEach((method) => {

    // temporary disable card payment
    // if (method.adapter === 'card_rec' || method.adapter === 'card') {
    //   return;
    // }

    //
    if (method.adapter === 'paysera' && !isEmpty(method.methodList)) {
      //
      if (Object.prototype.hasOwnProperty.call(method.methodList, 'eBanking')) {
        Object.values(method.methodList.eBanking).forEach((m) => {
          const option = (
            <a
              href={PaymentsStore.getPaymentMethodUrl(method.adapter, m.key)}
              onClick={(e) => onCheckout(e, `${method.adapter}_${m.key}`)}
              className={`btn tal paymentOption-button paymentOption-button--${method.adapter}`}
              key={`payment_option_${m.key}`}
            >
              <img
                src={m.logo}
                alt={m.title}
                className="paymentOption-image"
              />
              <svg className="icon">
                <use xlinkHref="#icon-arrowright" />
              </svg>
            </a>
          );
          iOptions.push(option);
        });
      }
      //
      if (Object.prototype.hasOwnProperty.call(method.methodList, 'eMoney')) {
        Object.values(method.methodList.eMoney).forEach((m) => {
          const option = (
            <a
              href={PaymentsStore.getPaymentMethodUrl(method.adapter, m.key)}
              onClick={(e) => onCheckout(e, `${method.adapter}_${m.key}`)}
              className={`btn tal paymentOption-button paymentOption-button--${method.adapter}`}
              key={`payment_option_${m.key}`}
            >
              <img
                src={m.logo}
                alt={m.title}
                className="paymentOption-image"
              />
              <svg className="icon">
                <use xlinkHref="#icon-arrowright" />
              </svg>
            </a>
          );
          options.push(option);
        });
      }
      return;
    }

    //
    let noteClass = '';
    if (method.recurring) {
      noteClass = ' paymentOption-button--withNote';
      recurring = true;
    }


    let paymentUrl = '';
    if (method.type === 'swed_payment') {
      paymentUrl = PaymentsStore.getSwedPaymentMethodUrl(method.adapter);
    } else {
      paymentUrl = PaymentsStore.getPaymentMethodUrl(method.adapter);
    }


    //
    const option = (
      <a
        href={paymentUrl}
        onClick={(e) => onCheckout(e, method.adapter)}
        className={`btn tal paymentOption-button paymentOption-button--${method.adapter}${noteClass}`}
        key={`payment_option_${counter}`}
      >
        <img
          src={`${get(globals, 'staticImageUri', '/')}${paymentImage(method.adapter)}`}
          className="paymentOption-image"
          alt=""
        />
        <svg className="icon">
          <use xlinkHref="#icon-arrowright" />
        </svg>
      </a>
    );

    //
    if (method.type === 'i_payment' || method.type === 'swed_payment') {
      iOptions.push(option);
    } else {
      options.push(option);
    }

    //
    counter += 1;
  });

  //
  return (
    <div className="paymentOption-regular">
      {options}
      {recurring && (
        <span className="paymentOption-footnote twb">{`* ${get(translations, recurringMessage, recurringMessage)}`}</span>
      )}
      {iOptions.length > 0 && (
        <div>
          <div className="block-title mts mbs">{get(translations, 'txt: Internetbankā', 'Internetbankā')}</div>
          {iOptions}
        </div>
      )}
    </div>
  );
};

PaymentOptions.propTypes = {
  recurringMessage: PropTypes.string,
  onCheckout: PropTypes.func.isRequired,
};

PaymentOptions.defaultProps = {
  recurringMessage: '',
};

export default PaymentOptions;
